import type { Question } from '@mentimeter/legacy-series-types/question';
import type { CompatibilitySlide } from '../../compatibility-types';
import { imageToQuestionImage } from '../converters/slide';

export const getLegacyImageProperty = (
  question: CompatibilitySlide,
  prop: keyof Question,
) => {
  const interactiveContent = question.interactiveContents?.[0];
  const image = interactiveContent?.image ?? question.images?.[0];

  if (!image) {
    return undefined;
  }

  if (prop === 'image') {
    return imageToQuestionImage(image);
  }

  if (prop === 'question_image_url' || prop === 'cropped_image_url') {
    return image.presets?.original?.url;
  }

  if (prop === 'image_alt_description') {
    return image.altText;
  }

  return undefined;
};
